import { render } from "./MediaSlider.vue?vue&type=template&id=a76ed172&scoped=true"
import script from "./MediaSlider.vue?vue&type=script&lang=js"
export * from "./MediaSlider.vue?vue&type=script&lang=js"

import "./MediaSlider.vue?vue&type=style&index=0&id=a76ed172&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a76ed172"]])

export default __exports__